import { render } from "./header-navigation.vue?vue&type=template&id=3b97220b"
import script from "./header-navigation.vue?vue&type=script&lang=js"
export * from "./header-navigation.vue?vue&type=script&lang=js"

import "./header-navigation.vue?vue&type=style&index=0&id=3b97220b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__